import Loadable from 'react-loadable';
import {HashRouter as Router, Route, Switch} from "react-router-dom";
import {H5RouteName} from "./common/routeName";
import {mPrint} from "./utils/mPrint";
import {EnvType, GlobalConfig} from "./common/appConfig";
import Vaccination from "./spa/vaccination/vaccination";
import FeedbackSelection from "./components/feedback/feedbackSelection";
import FeedbackEdit from "./components/feedback/feedbackEdit";
import FeedbackConfirm from "./components/feedback/feedbackConfirm";
import OpenApp from "./components/openApp/openApp";
import {GrayLog} from "./grayLog/grayLog";
import MTour from "./components/common/mTour/mTour";
import {VitalSignDetailSteps} from "./components/common/mTour/mSteps";

const Vaccine = Loadable({
    loader : () => import("./components/vaccine/vaccine"),
    loading() {
        return <div></div>
    },
})

const HomePageUI = Loadable({
    loader : () => import("./components/mainScreen/homePageUI"),
    loading() {
        return <div></div>
    },
})

const CovidVaccinationRecord = Loadable({
    loader : () => import("./components/vaccine/covidVaccinationRecord"),
    loading() {
        return <div></div>
    },
})

const covidVaccineAppointmentInfo = Loadable({
    loader : () => import("./components/vaccine/covidVaccineAppointmentInfo"),
    loading() {
        return <div></div>
    },
})

const doctorProfile = Loadable({
    loader : () => import("./components/doctor/doctorProfile"),
    loading() {
        return <div></div>
    },
})

const ErrorView = Loadable({
    loader : () => import("./components/common/errorView"),
    loading() {
        return <div></div>
    },
})

const QuestionList = Loadable({
    loader : () => import("./components/faq/questionList"),
    loading() {
        return <div></div>
    },
})

const QuestionDetail = Loadable({
    loader : () => import("./components/faq/questionDetail"),
    loading() {
        return <div></div>
    },
})

const PrivacyPolicy = Loadable({
    loader : () => import("./components/privacy/privacyPolicy"),
    loading() {
        return <div></div>
    },
})


const TermsOfUse = Loadable({
    loader : () => import("./components/privacy/termsOfUse"),
    loading() {
        return <div></div>
    },
})

const FindDoctor = Loadable({
    loader : () => import("./components/findDoctor/findDoctor"),
    loading() {
        return <div></div>
    },
})

const AppointmentDate = Loadable({
    loader : () => import("./components/doctor/appointmentDate"),
    loading() {
        return <div></div>
    },
})

const AppointmentDetail = Loadable({
    loader : () => import("./components/doctor/appointmentDetail"),
    loading() {
        return <div></div>
    },
})

const IdProofing = Loadable({
    loader : () => import("./components/idProofing/idProofing"),
    loading() {
        return <div></div>
    },
})

const VitalSignHome = Loadable({
    loader : () => import("./components/myMonitor/vitalSignHome"),
    loading() {
        return <div></div>
    },
})

const VitalSignDetail = Loadable({
    loader : () => import("./components/myMonitor/vitalSignDetail"),
    loading() {
        return <div></div>
    },
})

const VitalSignAdd = Loadable({
    loader : () => import("./components/myMonitor/vitalSignAdd"),
    loading() {
        return <div></div>
    },
})

const VitalSignList = Loadable({
    loader : () => import("./components/myMonitor/vitalSignList"),
    loading() {
        return <div></div>
    },
})

const MeasureHistory = Loadable({
    loader : () => import("./components/myMonitor/measureHistory"),
    loading() {
        return <div></div>
    },
})

const MeasureDetail = Loadable({
    loader : () => import("./components/myMonitor/measureDetail"),
    loading() {
        return <div></div>
    },
})

const UnitSettings = Loadable({
    loader : () => import("./components/myMonitor/vitalSignUnitSettings"),
    loading() {
        return <div></div>
    },
})

if (!window.passProps) {
    window.passProps = {};
}

function App() {
    GlobalConfig.isDebug = window?.isDebug || false;
    GlobalConfig.envType = window?.envType || EnvType.pro;
    mPrint(`Build date: ${GlobalConfig.buildDate} ${GlobalConfig.envType} - ${window?.isDebug}`);

    GrayLog.initialize();

    return (
        <Router>
            <Switch>
                <Route path={H5RouteName.spa.vaccination} exact component={Vaccination} />
                <Route path={H5RouteName.vaccine} exact component={Vaccine} />
                <Route path={H5RouteName.dashboard} exact component={HomePageUI}/>
                <Route path={H5RouteName.vaccineRecord} exact component={CovidVaccinationRecord} />
                <Route path={H5RouteName.vaccineAppointmentInfo} exact component={covidVaccineAppointmentInfo} />

                <Route path={H5RouteName.faq.questionList} exact component={QuestionList} />
                <Route path={H5RouteName.faq.questionDetail} exact component={QuestionDetail} />

                <Route path={`${H5RouteName.privacy.policy}/:app?`} exact component={PrivacyPolicy} />
                <Route path={`${H5RouteName.privacy.termsOfUse}/:app?`} exact component={TermsOfUse} />
                <Route path={H5RouteName.oa} exact component={OpenApp} />

                <Route path={H5RouteName.findDoctor.findDoctor} exact component={FindDoctor} />
                <Route path={H5RouteName.findDoctor.doctorProfile} exact component={doctorProfile} />
                <Route path={H5RouteName.findDoctor.appointmentDate} exact component={AppointmentDate} />
                <Route path={H5RouteName.findDoctor.appointmentDetail} exact component={AppointmentDetail} />
                <Route path={H5RouteName.idProofing} exact component={IdProofing} />

                <Route path={H5RouteName.feedback.selection} exact component={FeedbackSelection} />
                <Route path={H5RouteName.feedback.edit} exact component={FeedbackEdit} />
                <Route path={H5RouteName.feedback.confirm} exact component={FeedbackConfirm} />

                <Route path={H5RouteName.myMonitor.home} exact component={VitalSignHome} />
                <Route path={H5RouteName.myMonitor.detail} exact component={() => {
                    return (
                        <MTour
                            steps={VitalSignDetailSteps}
                            showBadge={false}
                            showNavigation={false}
                            showCloseButton={false}
                        >
                            <VitalSignDetail/>
                        </MTour>
                    )
                }} />
                <Route path={H5RouteName.myMonitor.add} exact component={VitalSignAdd} />
                <Route path={H5RouteName.myMonitor.list} exact component={VitalSignList} />
                <Route path={H5RouteName.myMonitor.measureHistory} exact component={MeasureHistory} />
                <Route path={H5RouteName.myMonitor.measureDetail} exact component={MeasureDetail} />
                <Route path={H5RouteName.myMonitor.unitSettings} exact component={UnitSettings} />

                <Route path="*" component={() => {
                    return <ErrorView />
                }} status={404} />
            </Switch>
        </Router>
    );
}

export default App;
